import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineEye, HiOutlineEyeOff } from "react-icons/hi";
import SummaryApi from "../common/SummaryApi";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../store/userSlice";
import { useLocation } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((preve) => ({ ...preve, [name]: value }));
  };

  const location = useLocation();
  const redirectTo = location.state?.redirectTo || "/admin-panel/admin-home";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(SummaryApi.signIn.url, {
        method: SummaryApi.signIn.method,
        headers: { "content-type": "application/json" },
        body: JSON.stringify(data),
      });

      const dataResponse = await response.json();
    console.log(dataResponse)
      if (dataResponse.success) {
        toast.success(dataResponse.message);
       
        localStorage.setItem("token", dataResponse.token);
        localStorage.setItem("user", JSON.stringify(dataResponse.user));

        const userRes = await axios.get(SummaryApi.getProfile.url, {
          headers: { Authorization: `Bearer ${dataResponse.token}` },
        });

        dispatch(setUserDetails(userRes?.data?.data));
        
        navigate(redirectTo, { state: location.state });
      } else {
        toast.error(dataResponse.message);
      }
    } catch (error) {
      toast.error("Connection error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md border border-gray-100">
        <h2 className="text-3xl font-bold mb-2 text-center text-[#414944]">Welcome Back</h2>
        <p className="text-sm mb-5 text-center text-gray-400">Login to your admin panel</p>

        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          {/* Email Label */}
          <label className="text-gray-700 font-medium">Email Address</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            className="w-full bg-white border border-gray-200 rounded-lg px-4 py-3 outline-none focus:border-green-500 transition-all"
            value={data.email}
            onChange={handleOnChange}
            required
          />

          {/* Password Label */}
          <label className="text-gray-700 font-medium">Password</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter your password"
              className="w-full bg-white border border-gray-200 rounded-lg px-4 py-3 outline-none focus:border-green-500 transition-all"
              value={data.password}
              onChange={handleOnChange}
              required
            />
            <div
              className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <HiOutlineEyeOff size={20} /> : <HiOutlineEye size={20} />}
            </div>
          </div>

          <div className="flex items-center justify-between text-sm text-gray-500 mt-1">
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" className="accent-green-600 w-4 h-4" />
              Remember me
            </label>
            <span
              onClick={() => navigate("/forgot-password")}
              className="text-[#0004FF] cursor-pointer transition-all"
            >
              Forgot Password?
            </span>
          </div>

          <button
            disabled={loading}
            className="w-full bg-[#00B207] text-white font-semibold py-3 rounded-full mt-4 transition-all shadow-md active:scale-95 disabled:opacity-70"
          >
            {loading ? "Logging In..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;